<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <!-- Page Wrapper -->
    <div class="customer-view-wrapper">
      <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
          <h5 class="mb-2">
            <div
              v-if="prev_page === 'view-estimate'"
              @click="router.go(-1)"
              class="d-flex align-center justify-content-start"
              style="color: #28084b; cursor: pointer"
            >
              <i class="feather feather-arrow-left me-1"></i>
              <span class="fs-6">Back</span>
            </div>
          </h5>
          <div class="content-invoice-header2">
            <div class="mt-2 mt-lg-0">
              <router-link :to="{ name: 'register' }" class="btn btn-primary"
                >Create free account</router-link
              >
            </div>
            <div class="list-btn">
              <ul class="filter-list flex-nowrap">
                <li>
                  <a
                    @click="openModal(estimate, 'download')"
                    class="btn-filters w-auto"
                    ><i class="fa fa-download" aria-hidden="true"></i
                  ></a>
                </li>
                <li>
                  <a @click="copyEstimateLink" class="btn-filters w-auto px-2"
                    ><i class="fa fa-clone me-2" aria-hidden="true"></i>Copy
                    link</a
                  >
                </li>
                <!-- <li
                >
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn btn-primary dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Action
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" @click="copyEstimateLink"
                        ><i class="fa fa-clone me-2"></i>Copy link</a
                      >
                      <a
                        v-if="
                          estimate.status == 'sent' ||
                          estimate.status == 'viewed' ||
                          estimate.status == 'draft'
                        "
                        class="dropdown-item"
                        @click="openModal(estimate, 'accept')"
                        ><i class="fa fa-check-circle text-success me-2"></i
                        >Accept Estimate</a
                      >
                      <a
                        v-if="
                          estimate.status == 'sent' ||
                          estimate.status == 'viewed' ||
                          estimate.status == 'draft'
                        "
                        class="dropdown-item"
                        @click="openModal(estimate, 'reject')"
                        ><i class="fa fa-times-circle text-danger me-2"></i
                        >Decline Estimate</a
                      >
                    </div>
                  </div>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
        <!-- /Page Header -->
        <div class="row justify-content-center" v-if="estimate">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="card-table">
                  <mobileestimateview
                    :estimate="estimate"
                    :totalProductDiscount="totalProductDiscount"
                    :vat="vat"
                  />
                  <!-- Desktop view -->
                  <div class="card-body d-invoice" id="estimate">
                    <!-- Invoice Logo -->
                    <div class="invoice-item invoice-item-one">
                      <div class="invoice-header">
                        <div class="col-md-4 col-lg-4">
                          <div class="invoice-logo">
                            <img
                              :src="estimate?.user?.setting?.business_logo"
                              alt="logo"
                            />
                          </div>
                        </div>
                        <div class="descrip col-md-6 col-lg-6">
                          <div class="invoice-info">
                            <h1 class="invoice-head mb-2">
                              {{ estimate?.estimate_id }}
                            </h1>
                            <p class="total-inner-p text-end me-2">
                              {{ estimate?.description }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Invoice Logo -->

                    <!-- Invoice To -->
                    <div class="invoice-item invoice-item-two">
                      <div
                        class="invoice-address d-flex justify-content-between"
                      >
                        <div class="invoice-to">
                          <p class="customer-text-one">Estimate From:</p>
                          <p class="invoice-details-two">
                            {{ estimate?.user?.name }}
                          </p>
                          <p class="invoice-details-two">
                            {{ estimate?.user?.email }}
                          </p>
                          <p class="invoice-details-two">
                            {{ estimate?.user?.phone }}
                          </p>
                          <p class="invoice-details-two">
                            {{ estimate?.user?.address }}
                          </p>
                          <p class="invoice-details-two">
                            {{ estimate?.user?.state }}
                            {{ estimate?.user?.country }}
                          </p>
                        </div>
                        <div class="invoice-to">
                          <p class="customer-text-one">Estimate To:</p>
                          <p class="invoice-details-two">
                            {{ estimate?.customer?.name }}<br />
                            {{ estimate?.customer?.email }}<br />
                            {{ `${estimate?.customer?.country_code} ${estimate?.customer?.phone}`

                            }}<br />
                            {{ estimate?.customer?.address }}<br />

                            {{ estimate?.customer?.state }}
                            {{ estimate?.customer?.country }}
                          </p>
                        </div>
                        <div class="invoice-to">
                          <p class="invoice-details-two text-end">
                            Status<br />
                            <span
                              class="invoice-status text-success"
                              v-if="
																estimate.status === 'sent' ||
																estimate.status === 'refunded' ||
																estimate.status === 'accepted'
															"
                              >{{ estimate.status }}</span
                            >
                            <span
                              class="invoice-status text-warning"
                              v-else-if="estimate.status === 'draft'"
                              >{{ estimate.status }}</span
                            >
                            <span
                              class="invoice-status text-danger"
                              v-else-if="
																estimate.status === 'expired' ||
																estimate.status === 'rejected'
															"
                              >{{ estimate.status }}</span
                            >
                          </p>
                          <p class="invoice-details-two text-end">
                            Date<br /><strong v-if="estimate.date">{{
															formatDateToDigits(estimate?.date)
                            }}</strong>
                          </p>
                          <p class="invoice-details-two text-end">
                            Due on<br /><strong v-if="estimate.due_date">{{
															formatDateToDigits(estimate?.due_date)
                            }}</strong>
                          </p>
                          <p class="invoice-details-two text-end">
                            Amount<br /><strong
                              >{{ estimate?.currency?.slice(0, 3) }}
                              {{
																addCurrencyComma(estimate?.total_amount)
                              }}</strong
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- /Invoice To -->

                    <!-- Invoice Item -->
                    <div class="invoice-item invoice-table-wrap">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive2">
                            <table class="table table-center table-hover mb-0">
                              <thead class="thead-light">
                                <tr>
                                  <th class="table-data">#</th>
                                  <th class="table-data">Product / Service</th>
                                  <th class="table-data">Quantity</th>
                                  <th class="table-data">Price</th>
                                  <th class="table-data">Discount</th>
                                  <th class="text-end table-data">Amount</th>
                                </tr>
                              </thead>
                              <tbody v-if="estimate.items">
                                <tr
                                  v-for="(item, index) in estimate.items"
                                  :key="index"
                                >
                                  <td class="table-data">{{ index + 1 }}</td>
                                  <td class="table-data">{{ item.name }}</td>
                                  <td class="table-data">
                                    {{ item.quantity }}
                                  </td>
                                  <td class="table-data">
                                    {{ estimate?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(item.price) }}
                                  </td>
                                  <td class="table-data">
                                    {{ item.discount }}%
                                  </td>
                                  <td class="text-end table-data">
                                    {{ estimate?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(item.amount) }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Invoice Item -->

                    <!-- Terms & Conditions -->
                    <div class="terms-conditions border-0">
                      <div class="row justify-content-end">
                        <div style="width: 48.5%; padding-right: 25px">
                          <div class="invoice-total-card">
                            <div class="invoice-total-box">
                              <div class="invoice-total-inner pt-2">
                                <p class="total-inner-p">
                                  Taxable Amount
                                  <span
                                    >{{ estimate?.currency?.slice(0, 3) }}
                                    {{ estimate?.amount }}</span
                                  >
                                </p>
                                <p class="total-inner-p">
                                  Discount<span
                                    >{{ estimate?.currency?.slice(0, 3) }}
                                    {{ totalProductDiscount }}</span
                                  >
                                </p>
                                <p
                                  class="total-inner-p"
                                  v-if="estimate?.tax_enabled === 1"
                                >
                                  {{ `VAT(${estimate?.tax_percentage}%)` }}
                                  <span
                                    >{{ estimate?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(vat) }}</span
                                  >
                                </p>
                                <p
                                  class="total-inner-p"
                                  v-for="(
																		discount, index
																	) in estimate?.more_discount"
                                  :key="index"
                                >
                                  {{ discount.description }}
                                  <span
                                    >- {{ estimate?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(discount.value) }}</span
                                  >
                                </p>
                                <p
                                  class="total-inner-p"
                                  v-for="(
																		charge, index
																	) in estimate?.additional_charges"
                                  :key="index"
                                >
                                  {{ charge.description }}
                                  <span
                                    >+ {{ estimate?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(charge.value) }}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Total -->
                    <div class="terms-conditions">
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <div style="width: 54%">
                          <div>
                            <p class="total-inner-p">
                              Total Items :
                              {{ estimate?.items?.length }}
                            </p>
                          </div>
                        </div>
                        <div style="width: 47.8%; padding-right: 10px">
                          <div class="invoice-total-card">
                            <div class="invoice-total-box">
                              <div class="invoice-total-footer">
                                <h4
                                  class="total-amount"
                                  style="font-size: 20px"
                                >
                                  Total Amount
                                  <span
                                    >{{ estimate?.currency?.slice(0, 3) }}
                                    {{
																			addCurrencyComma(estimate?.total_amount)
                                    }}</span
                                  >
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Total -->
                    <div class="terms-conditions">
                      <div style="display: flex; justify-content: start">
                        <div>
                          <div class="py-2">
                            <p class="total-inner-p">
                              Total Amount (in words):
                              <span
                                style="
																	margin-left: 2px;
																	color: black;
																	text-transform: capitalize;
																"
                                v-if="estimate?.total_amount"
                              >
                                {{
																	amountToWords(
																		estimate?.total_amount,
																		estimate?.currency
																	)
                                }}</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Note -->
                    <div class="terms-conditions">
                      <div style="display: flex">
                        <div>
                          <p class="bank-title total-amount">Note</p>
                          <div
                            class="total-inner-e"
                            v-html="estimate.notes"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>

  <!-- Delete Expense Modal -->
  <div class="modal custom-fade fade" id="delete_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>
              <span v-if="selectedAction === 'delete'">Delete Estimate</span>
              <span v-if="selectedAction === 'send'">Send Estimate</span>
              <span v-if="selectedAction === 'duplicate'"
                >Duplicate Estimate</span
              >
              <span v-if="selectedAction === 'reject'">Reject Estimate</span>
              <span v-if="selectedAction === 'accept'">Accept Estimate</span>
              <span v-if="selectedAction === 'download'"
                >Download Estimate</span
              >
            </h3>
            <p v-if="selectedItem">
              Are you sure want to
              <span v-if="selectedAction === 'delete'">delete</span>
              <span v-if="selectedAction === 'send'">send</span>
              <span v-if="selectedAction === 'duplicate'">duplicate</span>
              <span v-if="selectedAction === 'reject'">reject</span>
              <span v-if="selectedAction === 'accept'">accept</span>
              <span v-if="selectedAction === 'download'">download</span>
              <span class="fw-semibold ms-1">{{
								selectedItem.customer.name
              }}</span>
              Estimate?
            </p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row d-flex flex-column align-items-center">
              <div class="col-6 mb-2">
                <button
                  v-if="selectedAction === 'delete'"
                  @click="deleteEstimate"
                  class="w-100 btn btn-danger"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Delete</span>
                  <span v-if="isLoading">Deleting...</span>
                </button>
                <button
                  v-if="selectedAction === 'send'"
                  @click="sendEstimate"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Send</span>
                  <span v-if="isLoading">Sending...</span>
                </button>
                <button
                  v-if="selectedAction === 'reject'"
                  @click="markAs('rejected')"
                  class="w-100 btn btn-danger"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Reject</span>
                  <span v-if="isLoading">Rejecting...</span>
                </button>
                <button
                  v-if="selectedAction === 'accept'"
                  @click="markAs('accepted')"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Accept</span>
                  <span v-if="isLoading">Accepting...</span>
                </button>
                <button
                  v-if="selectedAction === 'duplicate'"
                  @click="duplicateEstimate"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Duplicate</span>
                  <span v-if="isLoading">Duplicating...</span>
                </button>
                <button
                  v-if="selectedAction === 'download'"
                  @click="downloadEstimate"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Download</span>
                  <span v-if="isLoading">Downloading...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Expense Modal -->
  <!-- /Main Wrapper -->
</template>
<script setup>
import { computed, onMounted, ref } from "vue";
import html2pdf from "html2pdf.js";
import { useStore } from "vuex";
import { onBeforeRouteLeave, useRoute, useRouter } from "vue-router";
import {
	addCurrencyComma,
	amountToWords,
} from "@/assets/composables/currency";
import { formatDateToDigits } from "@/assets/composables/date";
import { Modal } from "bootstrap";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });

const store = useStore();
const route = useRoute();
const router = useRouter();
const selectedItem = ref(null);
const selectedAction = ref(null);
const modalInstance = ref(null);
const isLoading = ref(false);
const taxableAmount = ref(0);
const totalCharges = ref(0);
const totalDiscount = ref(0);
const totalAmount = ref(0);
const tax_percentage = ref(0);
const vat = ref(0);
const totalProductDiscount = ref(0);

const openModal = (estimate, name) => {
	isLoading.value = false;
	selectedAction.value = name;
	selectedItem.value = estimate;
	modalInstance.value.show();
};
const closeModal = () => {
	modalInstance.value.hide();
};

const calculateCharges = () => {
	let totalcharges = 0;
	totalCharges.value = 0;
	for (let i = 0; i < estimate.value?.additional_charges?.length; i++) {
		const item = estimate.value.additional_charges[i];
		totalcharges += item.value;
	}
	totalCharges.value = totalcharges;
};
const calculateDiscount = () => {
	let totaldiscount = 0;
	totalDiscount.value = 0;
	for (let i = 0; i < estimate.value?.more_discount?.length; i++) {
		const item = estimate.value.more_discount[i];
		totaldiscount += item.value;
	}
	totalDiscount.value = totaldiscount;
};
const calculateTotalAmount = () => {
	// Caalculate Total amount
	let totalproductamount = 0;
	let totalproductdiscount = 0;
	let totalamount = 0;
	for (let i = 0; i < estimate.value?.items?.length; i++) {
		const item = estimate.value.items[i];
		totalproductamount += item.amount;
		totalproductdiscount += (item.discount / 100) * item.amount;
	}
	taxableAmount.value = totalproductamount;
	totalProductDiscount.value = totalproductdiscount;
	calculateCharges();
	calculateDiscount();
	let T1 = totalproductamount + totalCharges.value;
	let T2 = totalproductdiscount + totalDiscount.value;
	totalamount = T1 - T2;
	// Calculate Tax
	if (estimate.value.tax_enabled === 1) {
		vat.value = (tax_percentage.value * totalamount) / 100;
		totalAmount.value = totalamount + vat.value;
	} else {
		totalAmount.value = totalamount;
	}
};

const estimate = computed(() => {
	return store.getters["estimate/customer_estimate"];
});

let prev_page = localStorage.getItem("prev_page");

const getCustomerEstimate = async () => {
	await store
		.dispatch("estimate/getCustomerEstimate", route.params.id)
		.then(() => {
			tax_percentage.value = estimate.value?.tax_percentage;
		})
		.then(() => {
			calculateTotalAmount();
		});
};

const downloadEstimate = async () => {
	isLoading.value = true;
	let screenwidth = window.screen.width;
	const element = document.getElementById("estimate");
	if (screenwidth <= 960) {
		element.style.display = "block";
	}
	const options = {
		filename: `${estimate.value.estimate_id}.pdf`,
		image: { type: "jpeg", quality: 0.98 },
		html2canvas: {
			dpi: 192,
			letterRendering: true,
			allowTaint: true,
			useCORS: true,
			logging: true,
		},
		jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
	};
	const invoicedetailstwo = document.getElementsByClassName(
		"invoice-details-two"
	);
	const customertextone =
		document.getElementsByClassName("customer-text-one");
	const totalinnerp = document.getElementsByClassName("total-inner-p");
	const mobiledes = document.getElementsByClassName("descrip");
	const totalinnere = document.getElementsByClassName("total-inner-e");
	const totalamount = document.getElementsByClassName("total-amount");
	const tabledata = document.getElementsByClassName("table-data");
	const invoicehead = document.getElementsByClassName("invoice-head");
	for (let i = 0; i < invoicedetailstwo.length; i++) {
		invoicedetailstwo[i].style.fontSize = "12px";
	}
	for (let i = 0; i < customertextone.length; i++) {
		customertextone[i].style.fontSize = "12px";
	}
	for (let i = 0; i < totalinnerp.length; i++) {
		totalinnerp[i].style.fontSize = "12px";
	}
	for (let i = 0; i < mobiledes.length; i++) {
		mobiledes[i].style.width = "col-4";
	}
	for (let i = 0; i < totalamount.length; i++) {
		totalamount[i].style.fontSize = "14px";
	}
	for (let i = 0; i < tabledata.length; i++) {
		tabledata[i].style.fontSize = "12px";
	}
	for (let i = 0; i < invoicehead.length; i++) {
		invoicehead[i].style.fontSize = "22px";
	}
	for (let i = 0; i < totalinnere.length; i++) {
		totalinnere[i].fontSize = "12px";
	}
	await html2pdf()
		.set(options)
		.from(element)
		.save()
		.then(() => {
			for (let i = 0; i < invoicedetailstwo.length; i++) {
				invoicedetailstwo[i].style.fontSize = "14px";
			}
			for (let i = 0; i < customertextone.length; i++) {
				customertextone[i].style.fontSize = "14px";
			}
			for (let i = 0; i < totalinnerp.length; i++) {
				totalinnerp[i].style.fontSize = "14px";
			}
			for (let i = 0; i < totalamount.length; i++) {
				totalamount[i].style.fontSize = "20px";
			}
			for (let i = 0; i < tabledata.length; i++) {
				tabledata[i].style.fontSize = "14px";
			}
			for (let i = 0; i < invoicehead.length; i++) {
				invoicehead[i].style.fontSize = "26px";
			}
			for (let i = 0; i < totalinnere.length; i++) {
				totalinnere[i].fontSize = "14px";
			}
			if (screenwidth <= 960) {
				element.style.display = "none";
			}
			closeModal();
			isLoading.value = false;
		});
};

const duplicateEstimate = () => {
	isLoading.value = true;
	store
		.dispatch("estimate/duplicateEstimate", selectedItem.value.id)
		.then(() => {
			isLoading.value = false;
			closeModal();
		})
		.catch(() => {
			isLoading.value = false;
			closeModal();
		});
};
const deleteEstimate = () => {
	isLoading.value = true;
	store
		.dispatch("estimate/deleteEstimate", selectedItem.value.id)
		.then(() => {
			isLoading.value = false;
			closeModal();
			router.push("/estimates");
		})
		.catch(() => {
			isLoading.value = false;
			closeModal();
		});
};
const sendEstimate = () => {
	isLoading.value = true;
	store
		.dispatch("estimate/sendEstimate", selectedItem.value.id)
		.then(() => {
			isLoading.value = false;
			closeModal();
		})
		.catch(() => {
			isLoading.value = false;
			closeModal();
		});
};

const markAs = (action) => {
	isLoading.value = true;
	let data = {
		id: selectedItem.value.id,
		payload: {
			status: action,
		},
	};

	store
		.dispatch("estimate/markAs", data)
		.then(() => {
			isLoading.value = false;
			closeModal();
		})
		.catch(() => {
			isLoading.value = false;
			closeModal();
		});
};

// Copy estimate link
const link = window.location.href;
const copyEstimateLink = () => {
	if (!navigator.clipboard) {
		toast.error("Clipboard API is not supported in this browser.");
		return;
	}

	navigator.clipboard
		.writeText(link)
		.then(() => {
			toast.success("Link copied to clipboard");
		})
		.catch(() => {
			toast.error("Failed to copy link to clipboard");
		});
};

onMounted(() => {
	getCustomerEstimate();
	// Initiate modal
	modalInstance.value = new Modal(document.getElementById("delete_modal"), {
		backdrop: "static",
		keyboard: false,
	});
	store.dispatch("auth/getUser");
});

onBeforeRouteLeave((to, from, next) => {
	localStorage.removeItem("prev_page");
	next();
});
</script>
